const CrowdFundingABI =
	[
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_HopeWalet",
					"type": "address"
				},
				{
					"internalType": "contract IERC20",
					"name": "_HOPE",
					"type": "address"
				}
			],
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "owner",
					"type": "address"
				}
			],
			"name": "OwnableInvalidOwner",
			"type": "error"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "account",
					"type": "address"
				}
			],
			"name": "OwnableUnauthorizedAccount",
			"type": "error"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"inputs": [],
			"name": "HOPE",
			"outputs": [
				{
					"internalType": "contract IERC20",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "HopeWallet",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_addr",
					"type": "address"
				},
				{
					"internalType": "bool",
					"name": "_status",
					"type": "bool"
				}
			],
			"name": "addOrRemoveVolunteer",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_projectId",
					"type": "uint256"
				}
			],
			"name": "blockProject",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "string",
					"name": "_projectName",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "_projectDescription",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "_location",
					"type": "string"
				},
				{
					"internalType": "uint256",
					"name": "_targetTime",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_requiredFunds",
					"type": "uint256"
				},
				{
					"internalType": "string",
					"name": "facebook",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "twitter",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "instagram",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "socialLink",
					"type": "string"
				},
				{
					"internalType": "string[]",
					"name": "_tags",
					"type": "string[]"
				}
			],
			"name": "createProject",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "currentProjectId",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_projectId",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "donate",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_projectId",
					"type": "uint256"
				},
				{
					"internalType": "string",
					"name": "_projectName",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "_projectDescription",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "_location",
					"type": "string"
				},
				{
					"internalType": "uint256",
					"name": "_requiredFunds",
					"type": "uint256"
				},
				{
					"internalType": "string",
					"name": "facebook",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "twitter",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "instagram",
					"type": "string"
				},
				{
					"internalType": "string",
					"name": "socialLink",
					"type": "string"
				},
				{
					"internalType": "string[]",
					"name": "_tags",
					"type": "string[]"
				}
			],
			"name": "editProject",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "getAllProjects",
			"outputs": [
				{
					"components": [
						{
							"internalType": "uint256",
							"name": "projectId",
							"type": "uint256"
						},
						{
							"internalType": "string",
							"name": "projectName",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "projectDescription",
							"type": "string"
						},
						{
							"internalType": "address",
							"name": "createdBy",
							"type": "address"
						},
						{
							"internalType": "string",
							"name": "location",
							"type": "string"
						},
						{
							"internalType": "uint256",
							"name": "createdTime",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "targetTime",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "requiredFunds",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "raisedFunds",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "supporters",
							"type": "uint256"
						},
						{
							"internalType": "bool",
							"name": "withdawalStatus",
							"type": "bool"
						},
						{
							"internalType": "bool",
							"name": "blockedStatus",
							"type": "bool"
						},
						{
							"internalType": "string",
							"name": "facebook",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "twitter",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "instagram",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "socialLink",
							"type": "string"
						},
						{
							"internalType": "string[]",
							"name": "tags",
							"type": "string[]"
						}
					],
					"internalType": "struct hopeCrowdFunding.Project[]",
					"name": "",
					"type": "tuple[]"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_addr",
					"type": "address"
				}
			],
			"name": "getDonationInformation",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_id",
					"type": "uint256"
				}
			],
			"name": "getProject",
			"outputs": [
				{
					"components": [
						{
							"internalType": "uint256",
							"name": "projectId",
							"type": "uint256"
						},
						{
							"internalType": "string",
							"name": "projectName",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "projectDescription",
							"type": "string"
						},
						{
							"internalType": "address",
							"name": "createdBy",
							"type": "address"
						},
						{
							"internalType": "string",
							"name": "location",
							"type": "string"
						},
						{
							"internalType": "uint256",
							"name": "createdTime",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "targetTime",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "requiredFunds",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "raisedFunds",
							"type": "uint256"
						},
						{
							"internalType": "uint256",
							"name": "supporters",
							"type": "uint256"
						},
						{
							"internalType": "bool",
							"name": "withdawalStatus",
							"type": "bool"
						},
						{
							"internalType": "bool",
							"name": "blockedStatus",
							"type": "bool"
						},
						{
							"internalType": "string",
							"name": "facebook",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "twitter",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "instagram",
							"type": "string"
						},
						{
							"internalType": "string",
							"name": "socialLink",
							"type": "string"
						},
						{
							"internalType": "string[]",
							"name": "tags",
							"type": "string[]"
						}
					],
					"internalType": "struct hopeCrowdFunding.Project",
					"name": "",
					"type": "tuple"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_addr",
					"type": "address"
				}
			],
			"name": "isVolunteer",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "totalFundsDonated",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_blockedProjectId",
					"type": "uint256"
				},
				{
					"internalType": "uint256",
					"name": "_projectId",
					"type": "uint256"
				}
			],
			"name": "transferBlockedProjectFundsToNewProject",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "_projectId",
					"type": "uint256"
				}
			],
			"name": "withrawFunds",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	]

export default CrowdFundingABI;